/** @format — Open full /tracking map from AG-UI map cards */

const SESSION_KEY = "dockie_tracking_map_nav";

export function resolveTrackingCodeFromMapProps(props = {}) {
  const raw =
    props.bookingRef ??
    props.bookingId ??
    props.shipmentRef ??
    props.trackingCode ??
    props.shipmentId ??
    "";
  return String(raw).replace(/^#/, "").trim();
}

/** Persist map snapshot so /tracking can restore chat + map without re-streaming. */
export function persistTrackingMapView(props = {}) {
  try {
    sessionStorage.setItem(
      SESSION_KEY,
      JSON.stringify({
        props,
        code: resolveTrackingCodeFromMapProps(props),
        savedAt: Date.now(),
      }),
    );
  } catch {
    /* ignore */
  }
}

export function readTrackingMapView() {
  try {
    const raw = sessionStorage.getItem(SESSION_KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    if (!parsed || typeof parsed !== "object") return null;
    return parsed;
  } catch {
    return null;
  }
}

export function clearTrackingMapView() {
  try {
    sessionStorage.removeItem(SESSION_KEY);
  } catch {
    /* ignore */
  }
}

/** Build /tracking URL with optional track code query. */
export function buildTrackingPagePath(code) {
  const c = String(code ?? "").trim();
  if (!c) return "/tracking";
  return `/tracking?track=${encodeURIComponent(c)}`;
}

export const TRACKING_MAP_UI_ACTIONS = new Set([
  "view_full_map",
  "view_map",
  "open_tracking",
]);

export function isTrackingMapUiAction(actionId) {
  return TRACKING_MAP_UI_ACTIONS.has(actionId);
}
